var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogo = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_2",
  viewBox: "0 0 60 30",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "TYPO",
  transform: "translate(20, 0) scale(0.05, 0.05)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#29c778",
  d: "M458.03 185.07C458.03 67.61 376.9 0 245.92 0H68.08L2.93 87.3c-7.2 9.66-.31 23.4 11.74 23.4h222.79c63.38 0 98.03 33.8 98.03 85.35s-34.65 87.89-98.03 87.89h-114.88v-133.29H15.56c-8.59 0-15.56 6.96-15.56 15.56v418.22c0 8.59 6.96 15.56 15.56 15.56h107.03v-246.67l196.85 246.67h149.58c-112.39-131.83-164.79-194.37-196.9-228.17 79.44-2.53 185.92-53.24 185.92-186.76"
}))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.b93a96cc.svg";
export { ForwardRef as ReactComponent };